import EmptyMediaIcon from '../../../Icons/EmptyMediaIcon';
import useMediaStyles from '../../../useMediaStyles';
import { useProductMediaEmptyStateStyles } from './productMediaEmptyState.styles';

const ICON_SIZE_BY_SIZE = { thumbnail: 20, card: 48 } as const;

interface ProductMediaEmptyStateProps {
  aspectRatio?: string;
  size?: keyof typeof ICON_SIZE_BY_SIZE;
  className?: string;
}

const ProductMediaEmptyState = ({
  aspectRatio,
  size = 'card',
  className,
}: ProductMediaEmptyStateProps) => {
  const { classes: mediaClasses } = useMediaStyles({ imageAspectRatioPadding: aspectRatio });
  const { classes, cx } = useProductMediaEmptyStateStyles();

  return (
    <div className={cx(mediaClasses.mediaBoxWithAspectRatio, classes.root, className)}>
      <EmptyMediaIcon size={ICON_SIZE_BY_SIZE[size]} />
    </div>
  );
};

export default ProductMediaEmptyState;
